<div>
    <div class="box">
      <button (click)="onClickIntersect()" class="circle-intersect-button" id="vinSelectorTool" matTooltip="Seleccionar activos" matTooltipPosition="left">
        <img *ngIf="this.toolCarsSelectorservice.isCarSelectionToolVisible" [src]="'icon_vines.svg' | findUrl" class="img-button">
        <img *ngIf="!this.toolCarsSelectorservice.isCarSelectionToolVisible" [src]="'icon_vines.svg' | findUrl" class="img-button">
      </button>
      <div [@mostrarLista]="this.toolCarsSelectorservice.isCarSelectionToolVisible ? 'visible' : 'hidden'" class="vin-list">
        <div class="vin-tool-title">
          <h2>Identificadores</h2>
          <!-- <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false"  fontIcon="cancel" (click)="onClickIntersect()"></mat-icon> -->

        </div>
          <div [ngClass]="{'intersect-container-availability': isAvailabilityButton}" class="intersect-container" (mousedown)="$event.stopPropagation()" (mouseup)="$event.stopPropagation()">
            <div *ngFor="let feature of intersectedFeatures" class="vin-item">
              <label class="img-container">
                <!-- <img [src]="'icon_auto_vin_gris.svg' | findUrl" class="img-button"> -->
                <img [src]="'icon_control_activos.png' | findUrl" class="img-button">
              </label>
              <span>{{ feature.properties._Id }}</span>
            </div>
          </div>
          <div *ngIf="isAvailabilityButton" class="buttonContainer">
            <button mat-button class="btnAccept" style="color: white; height: 20px;" (click)="submitAvailability()">Apartar</button>
          </div>
      </div>
    </div>
  </div>